import React, { useEffect, useRef, useState} from "react";
import "./styles.css";
import { useTranslation } from "react-i18next";

function CustonInput({
  type = "text",
  label,
  value,
  onChange,
  showError = true,
  imageSrc,
  placeholder,
  disabled = false,
  className = "",
  options = [],
  onSelectOption,
  isCurrency = false,
  name = '',
  haslist = false,
  autoComplete = "off",
  autoOpenOnFocus = false,
}) {
  const [t, i18n] = useTranslation();
  const [displayValue, setDisplayValue] = useState('');
  const hoverTargetRef = useRef(null);
  const [hadInteraction, setHadInteraction] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [isCorrectValue, setIsCorrectValue] = useState(true);
  const [selectedOption, setSelectedOption] = useState({
    id: null,
    label: null,
  });
  const [isFocused, setIsFocused] = useState(false);

  const isSelectedOption = (optionId) => {
    return selectedOption.id == optionId;
  };

  const getMapedOptions = (options) => {
    const selectOption = (option) => {
      setIsHovered(false);
      setSelectedOption(option);
      onChange && onChange(option.label);
      onSelectOption && onSelectOption(option);
      setIsCorrectValue(true);
    };
    return options.length > 0
      ? options.map((option) => (
          <div
            key={option.id}
            value={option.id}
            onClick={() => selectOption(option)}
            className={`input-select-option ${
              isSelectedOption(option.id) && "selected"
            }`}
          >
            {option.label}
          </div>
        ))
      : [
        <div className="input-select-option no-results">
         {t('no_result')}
        </div>
      ];
  };

  const [optionsList, setOptionsList] = useState(getMapedOptions(options));
  const inputRef = useRef(null);
  useEffect(() => {
    setDisplayValue(formatCurrency(value));
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    setOptionsList(getMapedOptions(options));
  }, [selectedOption]);

  useEffect(() => {
    if (!isFocused) {
      setDisplayValue(formatCurrency(value));
    }
  }, [value, isFocused]);

  const handleContainerClick = () => {
    if (inputRef.current) {
      inputRef.current.focus();
      setIsHovered(true);
    }
  };

  const handleOnChange = (value) => {
    setHadInteraction(true);
    onChange&&onChange(value);

    if (value === "") {
      setIsCorrectValue(false);
    } else {
      setIsCorrectValue(true);
    }
    if (options.length > 0) {
      const filteredItems = options.filter((item) =>
        item.label.replace(/[\s,]+/g, '').toLowerCase().includes(value.replace(/[\s,]+/g, '').toLowerCase())
      );
      setOptionsList(getMapedOptions(filteredItems));
      const isACorrectinput = options.filter(
        (item) => item.label.toLowerCase() === value.toLowerCase()
      );

      if (isACorrectinput.length > 0) {
        setSelectedOption(isACorrectinput[0]);
        onChange && onChange(isACorrectinput[0].label);
        setIsCorrectValue(true);
        onSelectOption && onSelectOption(isACorrectinput[0]);
      }
      if (isACorrectinput.length === 0) {
        setIsCorrectValue(false);
        onSelectOption && onSelectOption(null);
        onChange&&onChange(value);
      }
    }
  };

  const errorClass = !isCorrectValue && showError ? "error" : "";

  const handleClickOutside = (event) => {
    if (
      hoverTargetRef.current &&
      !hoverTargetRef.current.contains(event.target)
    ) {
      setIsHovered(false);
      setIsFocused(false);
    }
  };

  const formatCurrency = (value) => {
    if (!value) return '';
    const number = parseFloat(String(value).replace(/[^0-9.]/g, ''));
    if (isNaN(number)) return '';
    return `$${number.toFixed(2)} USD`;
  };

  return (
    <div className="container-input-message" ref={hoverTargetRef}>
      <div
        className={`custom-input-container ${className} ${errorClass}`}
        onClick={handleContainerClick}
      >
        <label className="custom-input-label">{label}</label>
        <div className="custom-input-wrapper">
          <input
            type={type}
            step="1"
            className="custom-input-field"
            value={value}
            onChange={(e) => handleOnChange(e.target.value)}
            onFocus={() => {
              setIsFocused(true);
              if (autoOpenOnFocus && options.length > 0) {
                setIsHovered(true);
              }
            }}
            onBlur={() => {
              setIsFocused(false);
            }}
            placeholder={isCurrency && !isFocused ? displayValue || "$ 0.00 USD" : placeholder}
            ref={inputRef}
            name={name}
            disabled={ (disabled || (haslist && options?.length === 0))}
            autoComplete={autoComplete}
          />
         
          {imageSrc && (
            <img
              onChange={()=>{}}
              src={imageSrc}
              alt="country flag"
              className="custom-input-image"
            />
          )}
        </div>
      </div>
      {!isCorrectValue && showError && (
        <p className="error-message">Campo obligatorio*</p>
      )}
      {options.length > 0 && isHovered && (
        <div className="input-select-options">{optionsList}</div>
      )}
    </div>
  );
}

export { CustonInput };
